import {Dispatch} from 'react'
import {CREACION_USUARIO_TYPES} from '../../constants/creacionUsuario.types'
import {CreacionUsuarioAction} from '../../interfaces/creacionUsuario.interface'
import * as validators from '../../utils/validaciones'
import {State} from '../../reducers'
import {REGEX_TELEFONO} from '../../constants/Regex'
import {DICCIONARIO} from '../../constants/Diccionario'
import {validacionFechaMenorIgual} from '../../utils/stringDate'

// ******************************************************************************************
export const creacionUsuarioFormAddError = (error: any) => ({
  type: CREACION_USUARIO_TYPES.FORM_ADD_ERROR,
  payload: error,
})

export const creacionUsuarioFormAddErrorCode = (error: any) => ({
  type: CREACION_USUARIO_TYPES.FORM_ADD_ERROR_VERIFY_CODE,
  payload: error,
})

// ******************************************************************************************
export const validacionesCreacionUsuarioOnBlurUsuario =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<CreacionUsuarioAction>) => {
    let {name, value} = e.target
    let message = ''
    switch (name) {
      case 'username':
        message = validators.validacionEsRequerido(value, message, DICCIONARIO.USERNAME)
        if (!message) message = validators.validacionMinLenght(value, message, 2)
        break
      case 'passwd':
        message = validators.validacionEsRequerido(
          value,
          message,
          DICCIONARIO.PASSWORD,
          'requerida'
        )
        if (!message) message = validators.validacionPassword(value, message, DICCIONARIO.PASSWORD)
        break
      case 'passwd2':
        message = validators.validacionEsRequerido(
          value,
          message,
          DICCIONARIO.CONFIRM_PASSWORD,
          'requerida'
        )
        if (!message)
          message = validators.validacionPassword(value, message, DICCIONARIO.CONFIRM_PASSWORD)
        break
      default:
        break
    }

    dispatch(creacionUsuarioFormAddError({[name]: message}))
  }

export const validacionesCreacionUsuarioFormUsuarioSiguiente =
  () => async (dispatch: Dispatch<CreacionUsuarioAction>, getState: () => State) => {
    let {formUser, formError} = getState().creacionUsuario
    let errors = formError
    errors.username = validators.validacionEsRequerido(
      formUser.username,
      errors.username,
      DICCIONARIO.USERNAME
    )
    if (!errors.username)
      errors.username = validators.validacionMinLenght(formUser.username, errors.username, 2)

    errors.passwd = validators.validacionEsRequerido(
      formUser.passwd,
      errors.passwd,
      DICCIONARIO.PASSWORD,
      'requerida'
    )
    if (!errors.passwd)
      errors.passwd = validators.validacionPassword(
        formUser.passwd,
        errors.passwd,
        DICCIONARIO.PASSWORD
      )

    errors.passwd2 = validators.validacionEsRequerido(
      formUser.passwd2,
      errors.passwd2,
      DICCIONARIO.PASSWORD,
      'requerida'
    )
    if (!errors.passwd2)
      errors.passwd2 = validators.validacionPassword(
        formUser.passwd2,
        errors.passwd2,
        DICCIONARIO.CONFIRM_PASSWORD
      )

    if (formUser.passwd2 && formUser.passwd && formUser.passwd2 !== formUser.passwd)
      errors.passwd2 = 'Las contraseñas no coinciden'

    dispatch(creacionUsuarioFormAddError(errors))
    if (errors.username || errors.passwd || errors.passwd2) return true
    return false
  }

export const validacionesCreacionUsuarioOnBlurInformacion =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<CreacionUsuarioAction>, getState: () => State) => {
    let {name, value} = e.target
    let message = ''
    switch (name) {
      case 'birth_date':
        message = validators.validacionEsRequerido(
          value,
          message,
          DICCIONARIO.FECHA_NACIMIENTO,
          'requerida'
        )
        if (!message)
          message = validators.validacionFechaNacMayor17(
            value,
            message,
            DICCIONARIO.FECHA_NACIMIENTO
          )
        if (!message) message = validacionFechaMenorIgual(value, DICCIONARIO.FECHA_NACIMIENTO, 150)
        break
      case 'first_name':
        message = validators.validacionEsRequerido(value, message, DICCIONARIO.PRIMER_NOMBRE)
        if (!message) message = validators.validacionMaxLenght(value, message, 15)
        break
      case 'second_name':
        if (!message) message = validators.validacionMaxLenght(value, message, 15)
        break
      case 'third_name':
        if (!message) message = validators.validacionMaxLenght(value, message, 15)
        break
      case 'last_name':
        message = validators.validacionEsRequerido(value, message, DICCIONARIO.PRIMER_APELLIDO)
        if (!message) message = validators.validacionMaxLenght(value, message, 15)
        break
      case 'last_name2':
        if (!message) message = validators.validacionMaxLenght(value, message, 15)
        break
      case 'last_name_married':
        if (!message) message = validators.validacionMaxLenght(value, message, 15)
        break
      case 'nit':
        message = validators.validacionEsRequerido(value, message, DICCIONARIO.NIT)
        if (!message) message = validators.validacionMinLenght(value, message, 9)
        if (!message) message = validators.validacionNIT2(value, message, DICCIONARIO.NIT)
        break
      case 'tipoDocumento':
        message = validators.validacionEsRequerido(
          value,
          message,
          DICCIONARIO.TIPO_DOCUMENTO_IDENTIFICACION
        )
        break
      case 'id_number':
        message = validators.validacionEsRequerido(
          value,
          message,
          getState().creacionUsuario.formUser.nombreTipoDocumento
        )
        if (!message)
          message = validators.validarTipoDocumento(
            getState().creacionUsuario.formUser.nombreTipoDocumento!,
            value,
            message
          )
        break
      default:
        break
    }
    dispatch(creacionUsuarioFormAddError({[name]: message}))
  }

export const validacionesCreacionUsuarioFormInformacionSiguiente =
  () => async (dispatch: Dispatch<CreacionUsuarioAction>, getState: () => State) => {
    let {formUser, formError} = getState().creacionUsuario
    let errors = formError

    errors.birth_date = validators.validacionEsRequerido(
      formUser.birth_date,
      errors.birth_date,
      DICCIONARIO.FECHA_NACIMIENTO,
      'requerida'
    )
    if (!errors.birth_date)
      errors.birth_date = validators.validacionFechaNacMayor17(
        formUser.birth_date,
        errors.birth_date,
        DICCIONARIO.FECHA_NACIMIENTO
      )
    if (!errors.birth_date)
      errors.birth_date = validacionFechaMenorIgual(
        formUser.birth_date,
        DICCIONARIO.FECHA_NACIMIENTO,
        150
      )

    errors.first_name = validators.validacionEsRequerido(
      formUser.first_name,
      errors.first_name,
      DICCIONARIO.PRIMER_NOMBRE
    )

    errors.last_name = validators.validacionEsRequerido(
      formUser.last_name,
      errors.last_name,
      DICCIONARIO.PRIMER_APELLIDO
    )

    // errors.nit = validators.validacionEsRequerido(formUser.nit, errors.nit, DICCIONARIO.NIT)
    // if (!errors.nit) errors.nit = validators.validacionMinLenght(formUser.nit, errors.nit, 9)
    // if (!errors.nit)
    //   errors.nit = validators.validacionNIT2(formUser.nit, errors.nit, DICCIONARIO.NIT)

    errors.tipoDocumento = validators.validacionEsRequerido(
      formUser.tipoDocumento!,
      '',
      DICCIONARIO.TIPO_DOCUMENTO_IDENTIFICACION
    )

    // errors.id_number = validators.validacionEsRequerido(
    //   formUser.id_number,
    //   errors.id_number,
    //   errors.tipoDocumento ? DICCIONARIO.NUMERO_IDENTIFICACION : getState().creacionUsuario.formUser.nombreTipoDocumento
    // )

    errors.id_number = validators.validacionEsRequerido(
      formUser.id_number,
      '',
      errors.tipoDocumento
        ? DICCIONARIO.NUMERO_IDENTIFICACION
        : getState().creacionUsuario.formUser.nombreTipoDocumento
    )
    if (!errors.id_number)
      errors.id_number = validators.validarTipoDocumento(
        getState().creacionUsuario.formUser.nombreTipoDocumento!,
        formUser.id_number,
        ''
      )

    dispatch(creacionUsuarioFormAddError(errors))
    if (
      errors.birth_date ||
      errors.first_name ||
      errors.last_name ||
      // errors.nit ||
      errors.tipoDocumento ||
      errors.id_number
    )
      return true
    return false
  }

export const validacionesCreacionUsuarioOnBlurEmpresa =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<CreacionUsuarioAction>) => {
    let {name, value} = e.target
    let message = ''
    switch (name) {
      case 'codigo_empresa':
        message = validators.validacionEsRequerido(value, message, DICCIONARIO.CODIGO_EMPRESA)
        break
      default:
        break
    }

    dispatch(creacionUsuarioFormAddError({[name]: message}))
  }

export const validacionesCreacionUsuarioFormEmpresaSiguiente =
  () => async (dispatch: Dispatch<CreacionUsuarioAction>, getState: () => State) => {
    let {formUser, formError} = getState().creacionUsuario
    let errors = formError

    errors.codigo_empresa = validators.validacionEsRequerido(
      formUser.codigo_empresa,
      errors.codigo_empresa,
      DICCIONARIO.CODIGO_EMPRESA
    )

    dispatch(creacionUsuarioFormAddError(errors))
    if (errors.codigo_empresa) return true
    return false
  }

export const validacionesCreacionUsuarioOnBlurContacto =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<CreacionUsuarioAction>) => {
    let {name, value} = e.target

    let message = ''
    switch (name) {
      case 'email':
        message = validators.validacionEsRequerido(value, message, DICCIONARIO.EMAIL)
        if (!message) message = validators.validacionEmail(value, message, DICCIONARIO.EMAIL)
        break
      case 'phone_number':
        message = validators.validacionEsRequerido(value, message, DICCIONARIO.TELEFONO)
        if (!message) message = validators.validacionMinLenght(value, message, 8)
        if (!message)
          message = validators.validacionRegex(REGEX_TELEFONO, value, message, DICCIONARIO.TELEFONO)
        break
      case 'location':
        if (!message) message = validators.validacionMaxLenght(value, message, 100)
        // message = validators.validacionEsRequerido(value, message, 'Dirección', "requerida")
        break
      default:
        break
    }

    dispatch(creacionUsuarioFormAddError({[name]: message}))
  }

export const validacionesCreacionUsuarioFormContactoSiguiente =
  () => async (dispatch: Dispatch<CreacionUsuarioAction>, getState: () => State) => {
    let {formUser, formError} = getState().creacionUsuario
    let errors = formError

    errors.email = validators.validacionEsRequerido(formUser.email, errors.email, DICCIONARIO.EMAIL)
    if (!errors.email)
      errors.email = validators.validacionEmail(formUser.email, errors.email, DICCIONARIO.EMAIL)

    errors.phone_number = validators.validacionEsRequerido(
      formUser.phone_number,
      errors.phone_number,
      DICCIONARIO.TELEFONO
    )
    if (!errors.phone_number)
      errors.phone_number = validators.validacionMinLenght(
        formUser.phone_number,
        errors.phone_number,
        8
      )
    if (!errors.phone_number)
      errors.phone_number = validators.validacionRegex(
        REGEX_TELEFONO,
        formUser.phone_number,
        errors.phone_number,
        DICCIONARIO.TELEFONO
      )

    dispatch(creacionUsuarioFormAddError(errors))
    if (errors.email || errors.phone_number) return true
    return false
  }

export const validacionesCreacionUsuarioVerificarCodigo =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
  async (dispatch: Dispatch<CreacionUsuarioAction>) => {
    let {name, value} = e.target

    let message = ''
    switch (name) {
      case 'code':
        message = validators.validacionEsRequerido(value, message, DICCIONARIO.CODIGO_VERIFICACION)
        break
      default:
        break
    }

    dispatch(creacionUsuarioFormAddErrorCode({error: message}))
  }

export const validacionesCreacionUsuarioVerificarCodigoSiguiente =
  () => async (dispatch: Dispatch<CreacionUsuarioAction>, getState: () => State) => {
    let {code, error} = getState().creacionUsuario.codeVerify

    error = validators.validacionEsRequerido(code, error, DICCIONARIO.CODIGO_VERIFICACION)

    dispatch(creacionUsuarioFormAddErrorCode({error}))
    if (error) return true
    return false
  }
